export default __webpack_public_path__ + "static/binance-abb33b1f5a70bfab421974eaa2ae3996.png";